export default __webpack_public_path__ + "static/Cover-0dd66152f7bdab8f9fac8e882ffec8da.png";